<header class="page-header">
    <h1>{{'page.contact.name' | translate | upperFirstLetter }}</h1>
</header>